
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { RetentionPolicyTable } from '@/components/admin/certificates/RetentionPolicyTable';
import { RetentionExecutor } from '@/components/admin/certificates/RetentionExecutor';
import { RetentionScheduleManager } from '@/components/admin/certificates/RetentionScheduleManager';
import { RetentionVerificationReport } from '@/components/admin/certificates/RetentionVerificationReport';
import { Card } from '@/components/ui/card';
import { useIsMobile } from '@/hooks/use-mobile';

// Import our new components
import { RetentionHeader } from './retention/RetentionHeader';
import { HelpAlert } from './retention/HelpAlert';
import { ComplianceNoticeCard } from './retention/ComplianceNoticeCard';
import { ArchivesTabContent } from './retention/ArchivesTabContent';

export function RetentionManagementContent() {
  const [activeTab, setActiveTab] = useState("policies");
  const [showHelp, setShowHelp] = useState(true);
  const isMobile = useIsMobile();

  return (
    <div className="p-3 md:p-6 space-y-4 md:space-y-6">
      <RetentionHeader />
      
      <HelpAlert showHelp={showHelp} setShowHelp={setShowHelp} />

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
        <TabsList className={`flex flex-wrap gap-1 md:gap-0 ${isMobile ? 'w-full' : 'grid grid-cols-5 w-full md:w-auto'}`}>
          <TabsTrigger value="policies" className="whitespace-nowrap">Policies</TabsTrigger>
          <TabsTrigger value="execution" className="whitespace-nowrap">Execution</TabsTrigger>
          <TabsTrigger value="schedule" className="whitespace-nowrap">Schedule</TabsTrigger>
          <TabsTrigger value="verification" className="whitespace-nowrap">Verification</TabsTrigger>
          <TabsTrigger value="archives" className="whitespace-nowrap">Archives</TabsTrigger>
        </TabsList>
        
        <TabsContent value="policies" className="space-y-4">
          <Card>
            <RetentionPolicyTable />
          </Card>
        </TabsContent>
        
        <TabsContent value="execution" className="space-y-4">
          <RetentionExecutor />
        </TabsContent>
        
        <TabsContent value="schedule" className="space-y-4">
          <RetentionScheduleManager />
        </TabsContent>
        
        <TabsContent value="verification" className="space-y-4">
          <RetentionVerificationReport />
        </TabsContent>
        
        <TabsContent value="archives" className="space-y-4">
          <ArchivesTabContent />
        </TabsContent>
      </Tabs>
      
      <ComplianceNoticeCard />
    </div>
  );
}
